import { render, staticRenderFns } from "./DefBlock.vue?vue&type=template&id=69408067&scoped=true&"
import script from "./DefBlock.vue?vue&type=script&lang=js&"
export * from "./DefBlock.vue?vue&type=script&lang=js&"
import style0 from "./DefBlock.vue?vue&type=style&index=0&id=69408067&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69408067",
  null
  
)

export default component.exports